import { BroadcastService } from '../../core/services/broadcast.service';
import { Injectable, OnDestroy } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Constants } from './constants';

// TODO: Add Angular decorator.
@UntilDestroy()
@Injectable()
export abstract class ServiceManagerBase implements OnDestroy
{
    protected defaultPageSize: number = Constants.defaultDataPageSize;

    protected constructor(protected broadcastService: BroadcastService)
    {
        this.broadcastService.userSignedOut.pipe(untilDestroyed(this)).subscribe(() => this.clearCache());
        this.broadcastService.organizationChanged.pipe(untilDestroyed(this)).subscribe(() => this.clearCache());
    }

    ngOnDestroy()
    {
    }

    protected abstract clearCache();
}
